import React from 'react'
import { Text, Textarea } from 'react-form'
import {Form, Col, FormGroup, ControlLabel, Checkbox} from 'react-bootstrap'
import AdPriceButtons from './AdPriceButtons'

export default ({setValue, getValue, prices, user, horse, submitForm}) => {
  return (
    <Form horizontal onSubmit={submitForm}>
      <FormGroup>
        <Col componentClass={ControlLabel} xs={4}>
          قیمت
        </Col>
        <Col xs={8}>
          <Text
            field="price"
            type="text"
            placeholder="قیمت به تومان"
            disabled={getValue('price') === 'توافقی'}
            onChange={(e) => {
              const value = e.target.value
              if (value.length === 0) { return setValue('price', '') }
              if (value.match(/^[^0-9]/)) { return setValue('price', '') }
              const num = value.replace(/,/gi, '')
              setValue('price', parseInt(num, 10).toLocaleString())
            }}
            className="form-control"
          />
        </Col>
        <Col xs={8} xsOffset={4}>
          <Checkbox onChange={() => setValue('price', getValue('price') === 'توافقی' ? '' : 'توافقی')} inline>
              توافقی
          </Checkbox>
        </Col>
      </FormGroup>

      <FormGroup>
        <Col componentClass={ControlLabel} xs={4}>
          شماره تماس
        </Col>
        <Col xs={8}>
          <Text
            field="phone"
            type="text"
            placeholder="0912345678"
            className="form-control"
          />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col componentClass={ControlLabel} xs={4}>
          توضیحات
        </Col>
        <Col xs={8}>
          <Textarea
            field="description"
            className="form-control"
          />
        </Col>
      </FormGroup>

      <AdPriceButtons points={user.point} typeSetter={setValue} isMale={horse.genderType === 'male'} prices={prices} submit={submitForm} />
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseBreederOwner/AdBox/AdBoxForm.js